import api from '../../../App/socket';

export const createLeadAffiliate = params => (
    api.send({
        api: 'db',
        model: 'Lead_affiliate',
        action: 'Create',
        options: {
            create: params,
        },
    }).then(response => response).catch(error => error)
);



// WEBPACK FOOTER //
// ./src/modules/PlatformManagement/Manage_affiliates_create/requests/create_affiliate_request.js